module.exports = __webpack_public_path__ + "img/40_38_032_020.e8f390d2.jpg";